import React from 'react';

import {Spinner} from "reactstrap";
import {app} from "app/app";
import {InputEmail} from "components/common/InputEmail";
import {HeaderMobile} from "components/common/HeaderMobile";
import imageLogo from 'assets/img/common/img/icon-logo.svg';
import 'assets/sass/sign-up/ForgotPassword.scss';
import {ResetPasswordSentAnnouncement} from "buenLib/gtmNotifications/announcements/userAccount/ResetPasswordSentAnnouncement";
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import {getSetting, KEYS} from "../../settings/settings";

export default function ForgotPasswordController(props) {
    const [email, setEmail] = React.useState('');
    const [hasErrors, setHasErrors] = React.useState(false);
    const [passwordRecoveryEmailSent, setPasswordRecoveryEmailSent] = React.useState(false);
    const [requestInProgress, setRequestInProgress] = React.useState(false);
    const { executeRecaptcha } = useGoogleReCaptcha();

    React.useEffect(
        () => {
            let urlGETVariables = props.location.search;
            if (urlGETVariables) {
                const value = urlGETVariables.slice(1).split("=")[1];
                setEmail(value);
            }
        },
        []
    );

    function handleEmailChange(event) {
        setEmail(event.target.value);
    }

    function onResponse(response) {
        let responseHasErrors = response.hasError();
        setPasswordRecoveryEmailSent(!responseHasErrors);
        setHasErrors(responseHasErrors);
        setRequestInProgress(false);
        if (!responseHasErrors)
            app.announcer().announce(new ResetPasswordSentAnnouncement(email));
    }

    async function handleSubmit(ev) {
        ev.preventDefault();
        setRequestInProgress(true);
        const reCaptchaToken = getSetting(KEYS.RECAPTCHA_SITE_KEY) ? await executeRecaptcha('forgotPassword') : undefined;
        app.apiClient().forgotPassword(email, reCaptchaToken, onResponse);
    }

    function renderForm() {
        if (passwordRecoveryEmailSent)
            return null;

        if (requestInProgress)
            return <Spinner className="spinner-color" />

        return <div>
            <h1>¿Olvidaste tu contraseña?</h1>
            <p>Ingresá tu correo electrónico con el que te diste de alta inicialmente. Te enviaremos un
                link para recuperar tu clave.</p>
            <form onSubmit={handleSubmit}>
                <InputEmail placeholder="Ingresá tu Email" label="Email" name="email"
                            defaultValue={email}
                            onChange={(event) => handleEmailChange(event)}/>
                {hasErrors && (<div className="form-error">No pudimos enviar el link a este email. <br/>Por favor, intentalo nuevamente.</div>)}
                <button className="cta-button">ENVIAR LINK A ESTE MAIL</button>
            </form>
        </div>
    }

    function renderMessage() {
        if (!passwordRecoveryEmailSent)
            return null;

        return (
            <div>
                <h1>Link enviado</h1>
                <p>Ya enviamos el link para restablecer la contraseña a <b>{email}</b>, revisá
                    tus emails y seguí las instrucciones</p>
            </div>
        )
    }

    return (
        <div className="forgot-password">
            <HeaderMobile/>
            <div className="forgot-password-image"></div>
            <div className="forgot-password-content">
                <img className="logo" src={imageLogo} alt={app.productName()}/>
                {renderForm()}
                {renderMessage()}
            </div>
        </div>
    );
}
